<template>
    <div>
        <el-form :inline="true" :model="searchForm">
            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.iccid" clearable></el-input>
            </el-form-item>
            <el-form-item label="接入号：">
                <el-input v-model.trim="searchForm.intoNo" clearable></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary"  @click="deleteCardInBatchesListHandle">搜索查询</el-button>
                <el-button type="primary" @click="showDeleteChg">批量删除</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border  height="611" highlight-current-row>
            <el-table-column type="index" label="序号" width="50px"></el-table-column>
            <el-table-column label="ICCID号" width="180px">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="intoNo" label="接入号码" width="130px"></el-table-column>
            <el-table-column prop="supplierName" label="供应商名称"></el-table-column>
            <el-table-column prop="agentName" label="所属代理商"></el-table-column>
            <el-table-column prop="agentPathName" label="代理商层级"></el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>
        <el-dialog title="批量删除" :visible.sync="deleteVisible" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form :model="deleteForm" label-width="120px">
                <el-form-item label="导入Excel：">
                    <el-upload ref="upload" :action="uploadUrl('sim/batch/delete/sim')" :headers="setHeader()" :limit="1" :auto-upload="false" :data="deleteForm" :on-change="handleChange" :on-success = "handleSuccess">
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportHandle()">导出模板</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureDeleteChg">确 定</el-button>
            </div> 
        </el-dialog>   
    </div>
</template>
<script>
import {deleteCardInBatchesList } from '@/api/deleteCardInBatches.js'
import common from '@/utils/common.js'
export default {
    data(){         
        return {
            searchForm: {
                
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            deleteVisible: false,
            deleteForm: {
                simLife: null
            },

            currentId_fail: ''
        }
    },
    methods: {
        cancel(){
            this.deleteVisible = false;
        },
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('detailMenu').click();
        },
        deleteCardInBatchesListHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);            
            deleteCardInBatchesList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        showDeleteChg(){
            this.deleteVisible = true;
        },       
        sureDeleteChg(){
            this.$refs.upload.submit();   //号段批量导入
            cancel();
        },  
        exportHandle(){//导出excel文件
            var data = {};
            data.token = localStorage.getItem('token');
            this.exportExcel('/excel/sim/delete', data);
            this.$message.success('下载中……');
        },
        handleChange(file, fileList){
            if(fileList.length > 0){
                this.$refs.importCardForm.fields[0].clearValidate();
            }
        },      
        handleSuccess(res){
            if(res.code == 200){
                this.endtimeVisible = false;
                this.deleteCardInBatchesListHandle();
                this.$refs.upload.clearFiles();
                this.$message.success(res.message);
            }else{
                this.$message.error(res.message);
            }
        },   
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.deleteCardInBatchesListHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.deleteCardInBatchesListHandle();
        }         
    },
    created(){
        this.deleteCardInBatchesListHandle();
    }
}
</script> 